import { createTheme } from '@mui/material/styles';

/**
 * Кастомная тема ProxyTherm
 * Корпоративные цвета и стили
 */
const proxythermTheme = createTheme({
  palette: {
    primary: {
      main: '#d32f2f',      // Красный ProxyTherm (основной)
      light: '#e57373',     // Светло-красный
      dark: '#c62828',      // Темно-красный
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#757575',      // Серый для второстепенных элементов
      light: '#9e9e9e',
      dark: '#616161',
      contrastText: '#ffffff',
    },
    error: {
      main: '#f44336',
    },
    warning: {
      main: '#ff9800',
    },
    info: {
      main: '#2196f3',
    },
    success: {
      main: '#4caf50',
    },
    background: {
      default: '#f5f5f5',   // Светло-серый фон
      paper: '#ffffff',     // Белый для карточек
    },
    text: {
      primary: '#212121',
      secondary: '#757575',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
      fontSize: '3rem',
    },
    h2: {
      fontWeight: 700,
      fontSize: '2.5rem',
    },
    h3: {
      fontWeight: 600,
      fontSize: '2rem',
    },
    h4: {
      fontWeight: 600,
      fontSize: '1.75rem',
    },
    h5: {
      fontWeight: 600,
      fontSize: '1.5rem',
    },
    h6: {
      fontWeight: 600,
      fontSize: '1.25rem',
    },
    button: {
      textTransform: 'none', // Отключаем автоматический uppercase для кнопок
      fontWeight: 500,
    },
  },
  shape: {
    borderRadius: 8, // MUI использует px для shape.borderRadius
  },
  shadows: [
    'none',
    '0 2px 4px rgba(0,0,0,0.1)',
    '0 4px 8px rgba(0,0,0,0.12)',
    '0 8px 16px rgba(0,0,0,0.14)',
    '0 12px 24px rgba(0,0,0,0.16)',
    '0 16px 32px rgba(0,0,0,0.18)',
    '0 20px 40px rgba(0,0,0,0.2)',
    '0 24px 48px rgba(0,0,0,0.22)',
    '0 2px 4px rgba(211,47,47,0.15)', // Красная тень для акцентов
    '0 4px 8px rgba(211,47,47,0.2)',
    '0 8px 16px rgba(211,47,47,0.25)',
    '0 12px 24px rgba(211,47,47,0.3)',
    '0 16px 32px rgba(0,0,0,0.18)',
    '0 20px 40px rgba(0,0,0,0.2)',
    '0 24px 48px rgba(0,0,0,0.22)',
    '0 28px 56px rgba(0,0,0,0.24)',
    '0 32px 64px rgba(0,0,0,0.26)',
    '0 36px 72px rgba(0,0,0,0.28)',
    '0 40px 80px rgba(0,0,0,0.3)',
    '0 44px 88px rgba(0,0,0,0.32)',
    '0 48px 96px rgba(0,0,0,0.34)',
    '0 52px 104px rgba(0,0,0,0.36)',
    '0 56px 112px rgba(0,0,0,0.38)',
    '0 60px 120px rgba(0,0,0,0.4)',
    '0 64px 128px rgba(0,0,0,0.42)', // Добавлена 25-я тень (индекс 24)
  ],
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '0.5rem', // 8px
          padding: '0.625rem 1.5rem', // 10px 24px
          fontSize: '1rem',
          fontWeight: 500,
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 0.25rem 0.5rem rgba(0,0,0,0.15)',
          },
        },
        contained: {
          '&:hover': {
            boxShadow: '0 0.25rem 0.75rem rgba(211,47,47,0.3)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '0.75rem', // 12px
          boxShadow: '0 0.25rem 0.75rem rgba(0,0,0,0.08)',
          '&:hover': {
            boxShadow: '0 0.5rem 1.5rem rgba(0,0,0,0.12)',
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: '0 0.125rem 0.5rem rgba(0,0,0,0.1)',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: '0.5rem', // 8px
          },
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: '0.75rem', // 12px
        },
      },
    },
  },
});

export default proxythermTheme;
